import { ToastrService } from 'ngx-toastr';
import { Component, OnInit, ViewChild, ViewContainerRef, TemplateRef } from '@angular/core';
import { NgForm } from '@angular/forms';
import { AccessControlService } from 'src/app/services/access-control.service';
import { AlertService } from 'src/app/services/alert.service';
import { Router, ActivatedRoute } from '@angular/router';
import Swal from 'sweetalert2';
import { AuthConfig } from '../../model/auth-config.modals';
import { ClipboardService } from 'ngx-clipboard';
import { BsModalRef, BsModalService } from 'ngx-bootstrap';

@Component({
  selector: 'app-application-configuration',
  templateUrl: './application-configuration.component.html',
  styleUrls: ['./application-configuration.component.css']
})

export class ApplicationConfigurationComponent implements OnInit {
  @ViewChild('addapplicationForm') public addapplicationForm: NgForm;
  @ViewChild("containerRef", { read: ViewContainerRef }) containerRef!: ViewContainerRef;
  @ViewChild("multipleLocationTemplate", { read: TemplateRef }) templateRef!: TemplateRef<any>;


  appName: String = '';
  isExtensionError = false;
  isLogoSizeError = false;
  logo: any;
  username: string;
  model: any = AuthConfig;
  modalRef: BsModalRef;
  certificate;
  setUpComplete = false;
  saml_idp_sso_url = 'https://dev-25847509.okta.com/app/dev-25847509_expresssamlintegration_1/exk7g9zxgpHidFyPI5d7/sso/saml';
  saml_idp_issuer = 'http://www.okta.com/exk7g9zxgpHidFyPI5d7';
  name_id_format = [
    'urn:oasis:names:tc:SAML:1.1:nameid-format:emailAddress',
    'urn:oasis:names:tc:SAML:1.1:nameid-format:unspecified'

  ];
  saml_assertion = [{ key: 'Unsigned', value: false }, { key: 'Signed', value: true }];

  clientId: string;
  appId: string;
  isLoading: boolean;
  isSavingData = false;
  authType = 'oauth';

  constructor(private accesscontrolService: AccessControlService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private _clipboardService: ClipboardService,
    private toastrService: ToastrService,
    private modalService: BsModalService) {
    this.appId = this.activatedRoute.snapshot.params['id'];
    this.clientId = localStorage.getItem('user_id');
    this.appName = this.activatedRoute.snapshot.queryParams['appname'];
    this.model = new AuthConfig();

  }

  ngOnInit() {
    this.getApplicationAuthSettings();


  }
  AfterViewInit() {
    // if (this.locations.length > 0)
    //   this.renderLocationView()
  }
  submit() {
    // debugger;
    // if (!this.addapplicationForm.valid) {
    //   return;
    // }

    this.isSavingData = true;
    this.accesscontrolService.setApplicationAuthSettings(this.clientId, this.appId, this.model).subscribe(
      (result: any) => {
        this.isSavingData = false;
        if (!result.error) {
          this.toastrService.success('Setting saved successfully');
          this.router.navigate(['/client-apps']);
        }
      },
      (error: any) => {
        this.isSavingData = false;
        let errorMessage = error && error.error && error.error.message ? error.error.message : 'Sorry, Something went wrong!';
        this.toastrService.error(errorMessage);
      }
    );
  }


  getLogoDetails(e) {
    if (e && e.target && e.target.files[0]) {
      this.logo = (e.target.files[0]);
      this.getBase64(this.logo, (result) => {
        this.model.logo = result;
      },
        function (error) {
          console.log('Error: ', error);
        }
      );

      if (e.target.files[0].size > 300 * 1024) {
        this.isLogoSizeError = true;

      } else {
        this.isLogoSizeError = false;
      }
      let ext = this.logo.name.split('.').pop();
      ext = ext.toLowerCase();
      if (ext === 'jpg' || ext === 'jpeg' || ext === 'png' || ext === 'bmp' || ext === 'tiff') {
        this.isExtensionError = false;
      } else {
        this.isExtensionError = true;
      }
    }
  }

  getBase64(file, success, error) {
    let reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onerror = error;
    reader.onload = () => {
      success(reader.result);
    };
  }

  getApplicationAuthSettings() {
    this.isLoading = true;
    this.accesscontrolService.getApplicationAuthSettings(this.clientId, this.appId).subscribe(
      (response: any) => {
        if (!response.error) {
          this.certificate = response.certificate || '';
          if (response.data) {
            this.authType = response.data.auth_type || 'oauth';
            this.model.auth_config = response.data.auth_config || {};
            this.model.samlConfig = response.data.samlConfig || {}
            this.model.provisioning = response.data.provisioning || false
            if (this.model.samlConfig && this.model.samlConfig.audience_uri) {
              this.setUpComplete = true
            }
            if (response.data && response.data.urlInvalid)
              this.model.urlInvalid = response.data.urlInvalid
            else
              this.model.urlInvalid = {
                active: false,
                main_redirect_url: ''
              }
          }
          this.isLoading = false;
        }

      },
      (error: any) => {
        this.isLoading = false;
        let errorMessage = error && error.error && error.error.message ? error.error.message : 'Sorry, Something went wrong!';
        this.toastrService.error(errorMessage);
      }
    );
  }

  // renderSamlIdps() {
  //
  //   this.model.saml.forEach(
  //     (idp, index) => {
  //       debugger;
  //       this.viewContainerRef.createEmbeddedView(this.templateRef, { model: this.model.saml, index: index });
  //     }
  //   );
  // }
  callServiceToCopy() {
    if (this._clipboardService.copyFromContent(this.certificate)) {
      this.toastrService.success('Public key copied!', 'copied!',);
    } else {
      this.toastrService.error('Error in coping!', 'Error!');
    }
  }


  openModal(instructionTemplate) {
    let config = { backdrop: true, ignoreBackdropClick: true };
    this.modalRef = this.modalService.show(instructionTemplate, config);
  }

}
